<template>
  <v-toolbar
    dense
    class="mr-0 toolbar-without-padding"
    :color="userSettings.useDarkMode ? 'grey darken-3' : 'grey lighten-2'"
    style="padding-right: 0px; position: -webkit-sticky; /* Safari */
                                          position: sticky; "
  >
    <v-toolbar-items> </v-toolbar-items>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          class="ml-0"
          @click="openExplorer"
          flat
          v-on="on"
          style="font-weight: bold;"
          small
        >
          <v-icon
            class="pr-2"
            small
          >mdi-plus-box-outline</v-icon> Legg til innhold
        </v-btn>
      </template>
      <span>Legg til kartlag, tegnelag og filer</span>
    </v-tooltip>

    <v-spacer />

    <v-menu offset-y>
      <template v-slot:activator="{ on: menu }">
        <v-tooltip bottom>
          <template #activator="{ on: tooltip }">
            <v-btn
              flat
              label="Kartlag: Flere valg"
              aria-label="Kartlag: Flere valg"
              icon
              v-on="{ ...tooltip, ...menu }"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <span>Flere valg</span>
        </v-tooltip>
      </template>
      <v-list>
        <v-list-tile
          @click="saveProjectAs()"
          :disabled="!currentlyOpenedProject"
        >
          <v-list-tile-title>Lagre som</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="removeAllMapProfiles">
          <v-list-tile-title>Fjern alle kartlag</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          :disabled="!currentlyOpenedProject || !saveIsEnabled"
          @click="changeProjectSettings"
        >
          <v-list-tile-title>Endre kartinnstillinger</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <save-project-dialog
      v-if="saveProjectDialogActive"
      :active="saveProjectDialogActive"
      :save-project-settings="saveProjectSettings"
      @close-dialog="deactivateSaveProjectDialog"
    ></save-project-dialog>
  </v-toolbar>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SaveProjectDialog from "@/pages/MapPage/Tools/Saving/SaveProjectDialog";
import MappingMixin from "@/mixins/mappingMixin";

export default {
  name: "LayerListToolbar",
  components: {
    SaveProjectDialog
  },
  mixins: [MappingMixin],
  computed: {
    ...mapState(["currentlyOpenedProject", "saveIsEnabled", "userSettings"]),
    confirmNewEmptyProjectDialogText () {
      if (this.currentlyOpenedProject == null) {
        return "Når man oppretter et nytt tomt kart vil alt innhold fjernes fra kartet. Er du sikker på at du ønsker å fortsette?";
      } else {
        return (
          "Hvis du har gjort endringer i kartet '" +
          this.currentlyOpenedProject.attributes.tittel +
          "' som du ønsker å ta vare på må disse lagres før du fortsetter. Er du sikker på at du ønsker å fortsette?"
        );
      }
    }
  },
  methods: {
    ...mapActions([
      "enableSave",
      "setSnack",
      "removeCurrentlyOpenedProject",
      "setExplorerVisible"
    ]),
    openCreateNewEmptyDialog () {
      this.confirmNewEmptyProjectDialog = true;
    },
    createNewEmptyProject () {
      this.removeAllMapProfiles();
      this.removeCurrentlyOpenedProject();
      this.enableSave();
      this.closeConfirmNewEmptyProjectDialog();
    },
    closeConfirmNewEmptyProjectDialog () {
      this.confirmNewEmptyProjectDialog = false;
    },
    saveProject () {
      if (this.currentlyOpenedProject == null) {
        this.saveProjectSettings = false;
        this.activateSaveProjectDialog();
      } else {
        this.projectSaveInProgress = true;
        this.saveMap(this.currentlyOpenedProject)
          .then(result => {
            if (!result) {
              this.setSnack(
                "Lagring ble ikke gjennomført. Kun eier kan lagre endringer."
              );
            } else {
              this.setSnack("Kartet ble lagret");
            }
            this.projectSaveInProgress = false;
          })
          .catch(error => {
            console.error(error);
            this.setSnack("Lagring ikke gjennomført. Prøv igjen om litt.");
          });
      }
    },
    changeProjectSettings () {
      this.saveProjectSettings = true;
      this.activateSaveProjectDialog();
    },
    saveProjectAs () {
      this.saveProjectSettings = false;
      this.activateSaveProjectDialog();
    },
    deactivateOpenProjectDialog () {
      this.openProjectDialogActive = false;
    },
    deactivateSaveProjectDialog () {
      this.saveProjectDialogActive = false;
    },
    deactivateShareProjectDialog () {
      this.shareProjectDialogActive = false;
    },
    openExplorer () {
      this.setExplorerVisible(true);
    },
    activateOpenProjectDialog () {
      this.openProjectDialogActive = true;
    },
    activateSaveProjectDialog () {
      this.saveProjectDialogActive = true;
    },
    activateShareProjectDialog () {
      this.shareProjectDialogActive = true;
    }
  },
  data () {
    return {
      menu: false,
      openProjectDialogActive: false,
      saveProjectDialogActive: false,
      projectSaveInProgress: false,
      confirmNewEmptyProjectDialog: false,
      saveProjectSettings: false,
      shareProjectDialogActive: false
    };
  }
};
</script>

<style>
.toolbar-without-padding .v-toolbar__content {
  padding-left: 15px;
  padding-right: 8px;
}
</style>
